import MethodResultView from './views/MethodResultView';

export default function MethodResult() {
    return (
        <>
            <MethodResultView />
        </>
    );
}
